// Prints the codes alone: the page around them has no place on a sheet kept under lock
const printRecoveryCodes = (title, codes) => {
  const sheet = window.open('', '_blank', 'width=480,height=640');
  if (!sheet) return false;

  const heading = sheet.document.createElement('h3');
  heading.textContent = title;
  sheet.document.body.appendChild(heading);

  codes.forEach((thisCode) => {
    const line = sheet.document.createElement('p');
    line.style.fontFamily = 'monospace';
    line.style.fontSize = '18px';
    line.textContent = thisCode;
    sheet.document.body.appendChild(line);
  });

  sheet.document.close();
  sheet.focus();
  sheet.print();
  sheet.close();

  return true;
};

export default printRecoveryCodes;
